import React, { useState } from 'react';
import RevenueFYMReportTable_Man from '../components/RevenueFYMReportTable_Man';
import ManualRevenueManager from '../components/ManualRevenueManager';

const ManualRevenueDashboard = () => {
  // Define active tab state: 'report' is the default
  const [activeTab, setActiveTab] = useState('report');

  const tabContainerStyle = {
    display: 'flex',
    borderBottom: '2px solid #e2e8f0',
    marginBottom: '20px',
    gap: '8px'
  };

  const getTabStyle = (tabId) => ({
    padding: '10px 24px',
    fontSize: '14px',
    fontWeight: '700',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    borderBottom: activeTab === tabId ? '3px solid #0f172a' : '3px solid transparent',
    color: activeTab === tabId ? '#0f172a' : '#64748b',
    transition: 'all 0.2s ease',
    outline: 'none',
    marginBottom: '-2px' // Keeps active tab border aligned with container border
  });

  return (
    <div style={{ padding: '24px', backgroundColor: '#ffffff', minHeight: '80vh', borderRadius: '12px' }}>
      
      {/* Navigation Tabs Header */}
      <div style={tabContainerStyle}>
        <button 
          onClick={() => setActiveTab('report')} 
          style={getTabStyle('report')}
        >
          📈 Manual Revenue Report
        </button>
        <button 
          onClick={() => setActiveTab('manual')} 
          style={getTabStyle('manual')}
        >
          ✏️ Manual Revenue Updates
        </button>
      </div>

      {/* Dynamic View Content Render Panel */}
      <div style={{ marginTop: '10px' }}>
        {activeTab === 'report' ? (
          <RevenueFYMReportTable_Man />
        ) : (
          <ManualRevenueManager />
        )}
      </div>

    </div>
  );
};

export default ManualRevenueDashboard;